
import { FormDataService } from '../../_services/form-data.service';
import { CssInjectorService } from '../../_services/css-injector.service';
import { zip, Subject, concat, from, interval, takeWhile } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { WindowService } from '../../_services/window.service';
import { LandingHelperService } from '../../_services/landing-helper.service'
import { Component, OnInit, OnDestroy, Renderer2, Inject, PLATFORM_ID, NgZone, ElementRef, ViewChild } from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { FormSubmissionService } from '../../_services/form-submission.service';
import { ThankYouTelemetryService } from '../../_services/thank-you-telemetry.service';
import { Subscription } from 'rxjs';
import { ThankYouRouteService } from '../../_services/thank-you-route.service';

declare global {
  interface Window {
    MAO?: any;
    Mao?: any;    
    setMAOLocalStorageValue?: (key: string, value: any) => void;
    InitMAO?: (target: string, n?: number) => void;
    maoInit?: (config: any) => any;
  }
}

@Component({
  selector: 'app-thank-you-page-upsell',
  standalone: false,
  templateUrl: './thank-you-page-upsell.component.html',
  styleUrl: './thank-you-page-upsell.component.css'
})
export class ThankYouPageUpsellComponent implements OnInit, OnDestroy {
    private scriptEl?: HTMLScriptElement;
    private scriptLoadedPromise?: Promise<void> | null = null;
    private cssFaceLiftFileContent: string = '';
    private cssFaceliftPromise: Promise<string> | null = null;
    private isBrowser = false;
    currentLead: any = null;

    thankyouRoute: string = '';
    private loaderSubscription: Subscription | null = null;
    private loaderTimeoutId: any = null;
    private loaderIntervalId: any = null;


  constructor(
    private cssInjectorService : CssInjectorService,
    private http: HttpClient,
    private formSubmissionService: FormSubmissionService,
    private formDataService: FormDataService,
    private landingHelperService: LandingHelperService,
    private renderer: Renderer2,
    private window: WindowService,
    private ngZone: NgZone,
    public thankYouTelemetryService: ThankYouTelemetryService,
    public ThankYouRouteService: ThankYouRouteService,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private document: Document,
    
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }  

  

  async ngOnInit(): Promise<void> {
    if (!this.isBrowser) return;

    this.ThankYouRouteService.thankYouPageRoute$.subscribe(async (thanksSubId) => {    
      const thankYouRoute = await this.ThankYouRouteService.resolve(thanksSubId);
      this.thankyouRoute = thankYouRoute.provider.toLowerCase();
      if((thankYouRoute.provider || '').toLowerCase() == 'upsell') {        
        await this.initLoaderBar(5);   
        this.initUPSELLProcessValidation();
      }

      
    });


  }

  ngOnDestroy(): void {
    if (!this.isBrowser) {
      return;
    }

    if (this.scriptEl) {
      this.renderer.removeChild(this.document.body, this.scriptEl);
    }
  }

  private loadExternalScript(): Promise<void> {  
    const selector = "script[src='https://cdn.myadoptimizer.com/maojsfiles/landingpagesjs/fe2bfab1-b4ef-ef11-90c9-000d3a925ca4.js']";
    if (this.document.querySelector(selector)) {
      this.scriptLoadedPromise = Promise.resolve();
      return this.scriptLoadedPromise;
    }

    this.scriptLoadedPromise = new Promise<void>((resolve, reject) => {
      this.scriptEl = this.renderer.createElement('script') as HTMLScriptElement;
      this.scriptEl.type = 'text/javascript';
      this.scriptEl.src = 'https://cdn.myadoptimizer.com/maojsfiles/landingpagesjs/fe2bfab1-b4ef-ef11-90c9-000d3a925ca4.js';
      this.scriptEl.async = true;

      this.scriptEl.onload = () => resolve();
      this.scriptEl.onerror = () => reject(new Error('Failed to load external script'));

      this.renderer.appendChild(this.document.body, this.scriptEl);
    });  
    return this.scriptLoadedPromise;
  }

  async callScriptFunction(name: string, ...args: any[]): Promise<any> {
    try {
      await (this.scriptLoadedPromise ?? this.loadExternalScript());
    } catch (err) {
      return Promise.reject(err);
    }

    const globalObj = (window as any);

    if (typeof globalObj[name] === 'function') {
      return globalObj[name](...args);
    }

    const nsCandidates = ['MAO', 'Mao', 'mao', 'myAdOptimizer'];
    for (const ns of nsCandidates) {
      if (globalObj[ns] && typeof globalObj[ns][name] === 'function') {
        return globalObj[ns][name](...args);
      }
    }

    return Promise.reject(new Error(`Function ${name} not found on window or known namespaces`));
  }  

  async setMAOLocalStorageValue(key: string, value: any): Promise<void> {
    await (this.scriptLoadedPromise ?? this.loadExternalScript());

    const win = window as any;
    if (typeof win.setMAOLocalStorageValue === 'function') {
      return win.setMAOLocalStorageValue(key, value);
    }

    if (win.MAO && typeof win.MAO.setMAOLocalStorageValue === 'function') {
      return win.MAO.setMAOLocalStorageValue(key, value);
    }

    return Promise.reject(new Error('setMAOLocalStorageValue not found'));
  }  

  async initMAO(target: string, n: number = 1): Promise<any> {
    await (this.scriptLoadedPromise ?? this.loadExternalScript());

    const win = window as any;
    if (typeof win.InitMAO === 'function') {
      return win.InitMAO(target, n);
    }

    if (win.MAO && typeof win.MAO.InitMAO === 'function') {
      return win.MAO.InitMAO(target, n);
    }

    try {
      return await this.callScriptFunction('InitMAO', target, n);
    } catch (err) {
      return Promise.reject(new Error('InitMAO not found'));
    }
  }  

  // Move this function to Utils
  private capitalizedString(string: string): string {
    if (!string) return string;
    
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  }  

  async getCSSFacelift(): Promise<string> {
    if (!this.isBrowser) {
      return '';
    }

    if (this.cssFaceLiftFileContent) {
      return this.cssFaceLiftFileContent;
    }

    if (this.cssFaceliftPromise) {
      return this.cssFaceliftPromise;
    }

    const filePath = '/assets/css/thank-you-page/mao-facelift-v1.css';

    this.cssFaceliftPromise = new Promise<string>((resolve, reject) => {
      this.http.get(filePath, { responseType: 'text' }).subscribe({
        next: (data) => {
          this.cssFaceLiftFileContent = data;
          resolve(data);
        },
        error: (err) => {
          this.cssFaceliftPromise = null;
          console.error('Error reading file:', err);
          reject(err);
        }
      });
    });

    return this.cssFaceliftPromise;
  }

  initMAOListings() {
    if (!this.isBrowser) {
      return;
    }

    this.loadExternalScript();
    this.getCSSFacelift();
    this.formSubmissionService.getLeadObservable().subscribe(async lead => {
      if(lead && Object.keys(lead).length > 0) {
        this.currentLead = lead;
        console.log(lead)


        var cashOut = 'No';
        if (lead.CashOut * 1 > 0) {
            cashOut = 'Yes';
        }

        var vaStatus = 'No';
        if (lead.VAStatus && lead.VAStatus == 'true') {
            vaStatus = 'Yes';
        }

      if ((lead.LoanAmount * 1) >= (lead.EstimatedHomeValue * 0.95)) {
            lead.EstimatedHomeValue = lead.LoanAmount * 1.3;
            lead.EstimatedHomeValue = Math.trunc(lead.EstimatedHomeValue);
        }

        var CR = this.capitalizedString(lead.CreditRating)

        this.setMAOLocalStorageValue("zipcode", lead.Zip);
        this.setMAOLocalStorageValue("State", lead.State);
        this.setMAOLocalStorageValue("creditscore", CR);
        this.setMAOLocalStorageValue("loanbalance", lead.LoanAmount);
        this.setMAOLocalStorageValue("propertyvalue", lead.EstimatedHomeValue);
        this.setMAOLocalStorageValue("CashOut", cashOut);        
        this.setMAOLocalStorageValue("MediaChannel", "SMS");
        this.setMAOLocalStorageValue("MilitaryStatus", vaStatus);
        this.setMAOLocalStorageValue("PropertyType", lead.PropertyType);
        this.setMAOLocalStorageValue("FName", lead.FName);
        this.setMAOLocalStorageValue("LName", lead.LName);
        this.setMAOLocalStorageValue("Email", lead.Email);
        this.setMAOLocalStorageValue("Phone", lead.Phone);
        this.setMAOLocalStorageValue("Address", lead.Address);
        this.setMAOLocalStorageValue("City", lead.City);
        

        // lead.ThanksSubID = 'MAO'

        if(lead.ThanksSubID=='MAOET'){
          this.setMAOLocalStorageValue("SourceID", "113_CHL");
        }
        else { 
          if(lead.VerticalID == 6) {
            console.log('113_HLHS');
            this.setMAOLocalStorageValue("SourceID", "113_HLHS");

          } else {
            console.log('113_HL');
            this.setMAOLocalStorageValue("SourceID", "113_HL");

          }
        }
        this.setMAOLocalStorageValue("CustomVar1", "MAOHL");
        
        
        this.initMAO('target', 1);
        await this.getCSSFacelift();
        this.cssInjectorService.injectCSS('mao-thankyoupage-facelift', this.cssFaceLiftFileContent);        
      }   
    });
  }

  __initLoaderBar(loaderTimeSec: number): Promise<void> {
    if (!this.isBrowser) return Promise.resolve();

    // Limpiar temporizadores anteriores (para llamadas múltiples)
    if (this.loaderTimeoutId) clearTimeout(this.loaderTimeoutId);
    if (this.loaderIntervalId) clearInterval(this.loaderIntervalId);

    if (!loaderTimeSec || loaderTimeSec <= 0) loaderTimeSec = 2.5;

    const total = 100;
    let progress = 0;
    const loaderBar = this.window.document?.querySelector(".upsell-dynamic-loader-bar") as HTMLElement;

    // Actualizar barra cada cierto tiempo
    const intervalMs = (loaderTimeSec * 1000) / total;
    this.loaderIntervalId = setInterval(() => {
      progress++;
      if (loaderBar) {
        loaderBar.style.setProperty("--loaderprogress", `${(progress / total) * 100}%`);
      }
    }, intervalMs);

    // Usar setTimeout para resolver la promesa después del tiempo completo
    return new Promise((resolve) => {
      this.loaderTimeoutId = setTimeout(() => {
        // Asegurar que la barra llegue al 100%
        if (loaderBar) {
          loaderBar.style.setProperty("--loaderprogress", "100%");
        }
        // Limpiar el intervalo de la barra
        if (this.loaderIntervalId) {
          clearInterval(this.loaderIntervalId);
          this.loaderIntervalId = null;
        }
        this.loaderTimeoutId = null;
        resolve();
      }, loaderTimeSec * 1000);
    });
  }
  
  ___initLoaderBar(loaderTimeSec: number): Promise<void> {
    if (!this.isBrowser) return Promise.resolve();

    // Limpiar temporizadores anteriores
    if (this.loaderTimeoutId) clearTimeout(this.loaderTimeoutId);
    if (this.loaderIntervalId) clearInterval(this.loaderIntervalId);

    if (!loaderTimeSec || loaderTimeSec <= 0) loaderTimeSec = 2.5;

    const total = 100;
    let progress = 0;
    
    // IMPORTANTE: Usamos la clase del círculo SVG
    const loaderBar = document.querySelector(".upsell-dynamic-loader-bar") as HTMLElement;

    const intervalMs = (loaderTimeSec * 1000) / total;
    
    this.loaderIntervalId = setInterval(() => {
      progress++;
      if (loaderBar) {
        loaderBar.style.setProperty("--loaderprogress", `${(progress / total) * 100}`);
      }
    }, intervalMs);

    return new Promise((resolve) => {
      this.loaderTimeoutId = setTimeout(() => {
        if (loaderBar) {
          loaderBar.style.setProperty("--loaderprogress", "100");
        }
        if (this.loaderIntervalId) {
          clearInterval(this.loaderIntervalId);
          this.loaderIntervalId = null;
        }
        this.loaderTimeoutId = null;
        resolve();
      }, loaderTimeSec * 1000);
    });
  }

  initLoaderBar(loaderTimeSec: number): Promise<void> {
    if (!this.isBrowser) return Promise.resolve();

    if (this.loaderTimeoutId) clearTimeout(this.loaderTimeoutId);
    if (this.loaderIntervalId) clearInterval(this.loaderIntervalId);

    if (!loaderTimeSec || loaderTimeSec <= 0) loaderTimeSec = 2.5;

    const total = 100;
    let progress = 0;

    const loaderBar = document.querySelector(".upsell-dynamic-loader-bar") as HTMLElement;

    const intervalMs = (loaderTimeSec * 1000) / total;
    
    this.loaderIntervalId = setInterval(() => {
      progress++;
      if (loaderBar) {
        loaderBar.style.setProperty("--loaderprogress", `${(progress / total) * 100}`);
      }
    }, intervalMs);

    return new Promise((resolve) => {
      this.loaderTimeoutId = setTimeout(() => {
        if (loaderBar) {
          loaderBar.style.setProperty("--loaderprogress", "100");
        }
        if (this.loaderIntervalId) {
          clearInterval(this.loaderIntervalId);
          this.loaderIntervalId = null;
        }
        this.loaderTimeoutId = null;
        resolve();
      }, loaderTimeSec * 1000);
    });
  }  



  async initUPSELLProcessValidation() {
    this.formSubmissionService.getLeadObservable().subscribe(async lead => {
      if(lead && Object.keys(lead).length > 0) {    
        var ThanksSubIDSplited = lead.ThanksSubID ? lead.ThanksSubID.split('_') : [];
        if(ThanksSubIDSplited[1] > 0) {
          var UpsellOfferURLSettings = await this.landingHelperService.getActiveURLByOffer(ThanksSubIDSplited[1]); 
          var newRedirectURL = this.replaceOfferURLParams(UpsellOfferURLSettings[0]?.URL, lead, ThanksSubIDSplited[1], ThanksSubIDSplited[2], UpsellOfferURLSettings[0]?.OfferURLID);
          if(newRedirectURL != undefined && this.window.window) {
            this.window.window.location.href = newRedirectURL;          

          }
        }
      }
    });
  }

  replaceOfferURLParams(url: string, lead: any, OfferID: number, OfferThreadID: number, OfferURLID: number): string {
    let LongURL = url;
    let sourceID = '';   

    if (LongURL.includes("#ExternID#")) {
      console.log(lead?.ExternID)
      if (lead?.ExternID) {
        LongURL = LongURL.replace("#ExternID#", lead.ExternID);
      }
      sourceID = new URL(LongURL, window.location.origin).host;
    }
    if (LongURL.includes("#ListID#")) {
      LongURL = LongURL.replace("#ListID#", lead?.DialerListID?.toString() ?? '');
    }
    if (LongURL.includes("#Address#")) {
      LongURL = LongURL.replace("#Address#", this.toTitleCase(lead?.Address));
    }
    if (LongURL.includes("#City#")) {
      LongURL = LongURL.replace("#City#", lead?.City || '');
    }
    if (LongURL.includes("#State#")) {
      LongURL = LongURL.replace("#State#", lead?.State || '');
    }
    if (LongURL.includes("#Zip#")) {
      LongURL = LongURL.replace("#Zip#", lead?.Zip || '');
    }
    if (LongURL.includes("#CreditRating#")) {
      LongURL = LongURL.replace("#CreditRating#", lead?.CreditRating || '');
    }
    if (LongURL.includes("#InterestRateLoan1#")) {
      LongURL = LongURL.replace("#InterestRateLoan1#", lead?.InterestRateLoan1?.toString() ?? '');
    }
    if (LongURL.includes("#LoanType#")) {
      LongURL = LongURL.replace("#LoanType#", lead?.LoanType || '');
    }
    if (LongURL.includes("#VAStatus#")) {
      LongURL = LongURL.replace("#VAStatus#", lead?.VAStatus?.toString() ?? '');
    }
    if (LongURL.includes("#EstimatedHomeValue#")) {
      LongURL = LongURL.replace("#EstimatedHomeValue#", lead?.EstimatedHomeValue?.toString() ?? '');
    }
    if (LongURL.includes("#BalanceLoan1#")) {
      LongURL = LongURL.replace("#BalanceLoan1#", lead?.BalanceLoan1?.toString() ?? '');
    }
    if (LongURL.includes("#FName#")) {
      LongURL = LongURL.replace("#FName#", this.toTitleCase(lead?.FName));
    }
    if (LongURL.includes("#LName#")) {
      LongURL = LongURL.replace("#LName#", this.toTitleCase(lead?.LName));
    }
    if (LongURL.includes("#Email#")) {
      LongURL = LongURL.replace("#Email#", lead?.Email || '');
    }
    if (LongURL.includes("#Phone#")) {
      LongURL = LongURL.replace("#Phone#", lead?.Phone || '');
    }
    if (LongURL.includes("#RecordID#")) {
      LongURL = LongURL.replace("#RecordID#", lead?.LeadID?.toString() ?? '');
    }
    if (LongURL.includes("#TextSMSID#")) {
      LongURL = LongURL.replace("#TextSMSID#", lead?.TextSMSID?.toString() ?? '');
    }
    if (LongURL.includes("#RecordsForSMSReservedID#")) {
      LongURL = LongURL.replace("#RecordsForSMSReservedID#", lead?.RecordsForSMSReservedID?.toString() ?? '');
    }
    if (LongURL.includes("#MarketingChannelID#")) {
      LongURL = LongURL.replace("#MarketingChannelID#", lead?.MarketingChannelID?.toString() ?? '');
    }
    if (LongURL.includes("#DynamicImgVersion#")) {
      LongURL = LongURL.replace("#DynamicImgVersion#", lead?.ImgVersion || '');
    }
    if (LongURL.includes("#TrafficSourceID#")) {
      LongURL = LongURL.replace("#TrafficSourceID#", lead?.TrafficSourceID || '');
    }
    if (LongURL.includes("#ThankYouSubID#")) {
      LongURL = LongURL.replace("#ThankYouSubID#", lead?.ThankYouSubID || '');
    }
    if (LongURL.includes("#CampaignID#")) {
      LongURL = LongURL.replace("#CampaignID#", lead?.CampaignID || '');
    }

    if (!sourceID) {
      sourceID = new URL(LongURL, window.location.origin).host;
    } 

    if (!LongURL.includes("?")) {
      LongURL += "?";
    } else {
      LongURL += "&";
    }

    LongURL += "confirmation=" + (lead?.Phone || '') + "&SourceID=2&ShowSubmit=1&RecordsForSMSReservedAutoID=" + (lead?.RecordsForSMSReservedID?.toString() ?? '');
    if (!LongURL.includes("utm_source")) {
      LongURL += "&utm_source=SMS_" + OfferID + "_" + OfferThreadID;
    }
    LongURL += "&OfferURLID=" + (OfferURLID || 0);
    LongURL += "&utm_medium=" + (lead?.DialerListID?.toString() ?? '') + "&utm_campaign=" + lead.utm_campaign + "&utm_content=" + lead.utm_content + "&utm_term=" + (lead?.utm_term || '');
    LongURL += "&RecordID=" + (lead?.RecordID || '') + "&DialerListID=" + (lead?.DialerListID || '') + "&FName=" + (lead?.FName || '') + "&Address=" + (lead?.Address || '');
    LongURL = LongURL.replace("{SHORTURL}", lead?.SHORTURL || '');
    
    if (lead.TCPABrandID) {
      LongURL += "&TCPABrandID=" + (lead?.TCPABrandID?.toString() ?? '');
    }
    if (lead.DisclosID) {
      LongURL += "&DisclosID=" + (lead?.DisclosID?.toString() ?? '');
    }

    return LongURL;
  }

  toTitleCase(str: string): string {
    return str
      .trim()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }



}
